<div class="row justify-content-center">
    <div class="col-sm-8 col-12">
        <div class="card floating shadow-lg">
            <div class="card-body">
                <h3 class="card-title main-title">Email verification</h3>
                <div class="row">
                    <div class="col">
                        <mat-form-field appearance="outline">
                            <mat-label>Email Verification Code*</mat-label>
                            <input matInput [(ngModel)]="currentEmailVerificationCode" type="text">
                            <mat-hint>
                                <a class="resend" (click)="resend()">Resend email verification code</a>
                            </mat-hint>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="row card-footer">
                <div class="col text-center">
                    <a class="btn btn-blue" (click)="submit()">Submit</a>
                    <a class="btn btn-secondary" (click)="backToProfile()">Back to profile</a>
                </div>
            </div>
        </div>
    </div>
</div>